import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

interface CometNotificationProps {
  catcherName: string | null;
  onDismiss: () => void;
}

export const CometNotification = ({ catcherName, onDismiss }: CometNotificationProps) => {
  useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (catcherName) {
      setIsVisible(true);

      // Fade out after 3 seconds
      const fadeTimer = setTimeout(() => {
        setIsVisible(false);
      }, 3000);

      // Dismiss after animation completes
      const dismissTimer = setTimeout(() => {
        onDismiss();
      }, 3500);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(dismissTimer);
      };
    }
  }, [catcherName, onDismiss]);

  if (!catcherName) return null;

  return (
    <div
      className={`fixed top-20 left-1/2 transform -translate-x-1/2 z-50 pointer-events-none transition-opacity duration-500 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="px-6 py-3 rounded-lg bg-black/70 border border-white/20 backdrop-blur-sm">
        <p className="text-center">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-yellow-500 via-green-500 via-blue-500 to-purple-500 animate-pulse font-bold">
            <Trans i18nKey="comet.label" />
          </span>
          <span className="text-white/90 ml-2">
            <Trans
              i18nKey="comet.caughtBy"
              values={{ name: catcherName }}
              components={{ highlight: <span className="text-cyan-400 font-semibold" /> }}
            />
          </span>
        </p>
      </div>
    </div>
  );
};
